import React from 'react';
import styled from 'styled-components';

import {
  BUTTON_THEMES,
  BUTTON_TYPES,
  ELEMENT_ACTION,
  ICON_TYPES,
} from '../../../shared/constants';

import PrimaryButton from '../../atoms/primary-button/PrimaryButton';

import { DEQ_TYPES } from '../../../utils/deq';

import mq from '../../../styles/breakpoints';
import Colors from '../../../styles/colors';
import { H2 } from '../../../styles/generic';
import Spacings from '../../../styles/Spacings';

interface Props {
  title: string;
  buttonText: string;
  file: string;
  className?: string;
}

const DownloadCard = ({ title, buttonText, file, className }: Props) => (
  <Container className={className}>
    <Title>{title}</Title>
    <StyledPrimaryButton
      to={file}
      icon={ICON_TYPES.download}
      buttonTheme={BUTTON_THEMES.highlight}
      className="download-button"
      deqComponentTitle={title}
      label={buttonText}
      type={BUTTON_TYPES.file}
      deqCustomAttributes={{
        type: DEQ_TYPES.button,
        elementTarget: `${file}`,
        elementAction: ELEMENT_ACTION.download,
      }}
    />
  </Container>
);

const Container = styled.div`
  align-items: center;
  background-color: ${Colors.white};
  box-shadow: ${({ theme }) => theme.elevations.abnElevationWell};
  box-sizing: border-box;
  color: ${Colors.black};
  display: flex;
  flex-direction: column;
  padding: ${Spacings.L} ${Spacings.XS};

  ${mq.from.breakpoint.M`
    padding: ${Spacings.L} ${Spacings.M};
  `}

  ${mq.from.breakpoint.L`
    padding: ${Spacings.L};
  `}
`;

const Title = styled(H2)`
  margin: 0 0 ${Spacings.L};
  text-align: center;

  ${mq.to.breakpoint.M`
    font-size: ${({ theme }) => theme.h3.fontSize.S};
    line-height: ${({ theme }) => theme.h3.lineHeight.S};
    margin: 0 0 ${Spacings.M};
  `}
`;

const StyledPrimaryButton = styled(PrimaryButton)`
  ${mq.to.breakpoint.M`
    box-sizing: border-box;
    width: 100%;
  `}
`;

export default DownloadCard;
